import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";

class FactorDetail extends Component {
  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.props.factorDetail}
          toggle={() => this.props.changeModal(!this.props.factorDetail)}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-4 py-3 fw-bolder fs-6 align-self-center border-bottom">
              فاکتور
            </div>
            <div className="col-12 px-4 py-3 fw-bolder fs-6 align-self-center border-bottom">
              {this.props.price && (
                <div className="row px-0 mx-0">
                  <div className="col px-0 align-self-center">قیمت محصولات</div>
                  <div className="col-auto fs-5 px-0 color-main fw-bolder">
                    {this.props.price.title}
                    <span className="fs-7 me-1">
                      {this.props.price.currency}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 px-4 py-3 fw-bolder fs-6 align-self-center border-bottom">
              {this.props.discount && (
                <div className="row px-0 mx-0">
                  <div className="col px-0 align-self-center">تخفیف ها</div>
                  <div className="col-auto fs-5 px-0 color-main fw-bolder">
                    {this.props.discount.title}
                    <span className="fs-7 me-1">
                      {this.props.discount.currency}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 px-4 py-3 fw-bolder fs-6 align-self-center border-bottom">
              {this.props.shipping && (
                <div className="row px-0 mx-0">
                  <div className="col px-0 align-self-center">هزینه ارسال</div>
                  <div className="col-auto fs-5 px-0 color-second fw-bolder">
                    {this.props.shipping.title}
                    <span className="fs-7 me-1">
                      {this.props.shipping.currency}
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="col-12 px-4 py-3 fw-bolder fs-6 align-self-center border-bottom">
              {this.props.payable_price && (
                <div className="row px-0 mx-0">
                  <div className="col px-0 align-self-center">جمع کل</div>
                  <div className="col-auto fs-5 px-0 fw-bolder">
                    {this.props.payable_price.title}
                    <span className="fs-7 me-1">
                      {this.props.payable_price.currency}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default FactorDetail;
